/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarFormsAppStatusChirpUIService
 */

export const appStatusRpc = {
  serviceName: 'com.hubspot.video.conference.component.rpc.ui.service.v1.WebinarFormsAppStatusChirpUIService',
  rpcName: 'appStatus',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAyzRNrjlWUtKyQTP9i5qss'
};